import React from "react";
import AlternativeHeader from "../../../../components/Headers/AlternativeHeader";

export default () => {
  return <AlternativeHeader name={"Documents"} product={"Workforce"} />;
};
